import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReferenceMeasureService {
  private referenceMeasureUpdateSubject = new BehaviorSubject<void>(undefined);
  referenceMeasureUpdate$ = this.referenceMeasureUpdateSubject.asObservable();

  refreshReferenceMeasure() {
    this.referenceMeasureUpdateSubject.next();
  }
}
